export const SCENARIO_RESULT_FAILED = 'Scenario result fetch was failed.';
export const DEFAULT_PAGINATION_PROPS = {
  current: 1,
  pageSize: 20
};
export const UNIFIED_ALERTS_SOURCE_IDS = '8,20';
export const UNIFIED_ALERTS_SOURCE_IDS_PREVENTION = '24,';
export const UNIFIED_ALERTS_SOURCE_IDS_TM = '8,';
export const UNIFIED_ALERTS_SOURCE_IDS_FRAUD = '20,';
export const UNIFIED_ALERTS_SOURCE_IDS_FRAUD_PREVENTION = '24,';
export const UNIFIED_ALERTS_SOURCE_IDS_FRAUD_PREVENTION_PRODUCTION =
  '0,1,6,4,2,3,5,10,11,12,13,14,18,21,25,29,30';
export const ALERT__REQUEST_SOURCE_ID = 8;
export const REVIEW_REQUEST_STATUS = 6;
